import React, { FunctionComponent } from 'react'

import styled from 'styled-components/native'

import { CDN_ASSETS_LINK_BASE } from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/constants'

import { AccessibilityRolesNative } from '../../constants'
import { tID } from '../../utils/utils'
import { Image } from '../image/Image'

type OrbIllustrationProps = {
  size?: number
}

const OrbContainer = styled.View<{ size: number; offset: number }>(({ size, offset }) => ({
  margin: `-${offset}px`,
  width: `${size}px`,
  height: `${size}px`,
}))

export const OrbIllustration: FunctionComponent<OrbIllustrationProps> = ({ size = 284 }) => {
  const adjustedSize = size * 1.22 // Size adjusted to account for the blur effect that overflows the edges
  const offset = adjustedSize * 0.1
  return (
    <OrbContainer size={adjustedSize} offset={offset}>
      <Image
        dataSet={{ chromatic: 'ignore' }}
        testID={tID('OrbIllustration')}
        source={`${CDN_ASSETS_LINK_BASE}/aurora/orb.png`}
        style={{ width: adjustedSize, height: adjustedSize }}
        accessibilityIgnoresInvertColors={true}
        accessibilityRole={AccessibilityRolesNative.IMAGE}
        contentFit='contain'
      />
    </OrbContainer>
  )
}
